import axios from 'axios';

import { ClientSummary, Client, ListResponse, ApiConfig, PartialUpdateEntity } from '../types';
import {
  toSerializedError,
} from '../errors/utils';

export type ListClientsResponse = ListResponse<ClientSummary>;

export async function listClients({ api_url, headers }: ApiConfig, tenant_id: string) {
  try {
    let res = await axios.get<ListClientsResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/clients', {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type CreateClientParams = {
  tenant_id: string;
  body: Pick<Client,
    |'name'|'description'|'full_role_id'
    |'access_token'|'refresh_token'|'username'|'providers'
    |'is_published'|'state'|'authorized_redirect_uris'
  >;
};
export type CreateClientResponse = Pick<Client, 'client_id'|'client_secret'> & {
  request_id: string;
};

export async function createClient(
  { api_url, headers }: ApiConfig,
  { tenant_id, body }: CreateClientParams,
) {
  try {
    let res = await axios.post<CreateClientResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/clients', body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type GetClientParams = {
  tenant_id: string;
  client_name: string;
};
export type GetClientResponse = Client;

export async function getClient(
  { api_url, headers }: ApiConfig,
  { tenant_id, client_name }: GetClientParams,
) {
  try {
    let res = await axios.get<GetClientResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/clients/'+client_name, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type UpdateClientParams = {
  tenant_id: string;
  client_name: string;
  body: PartialUpdateEntity<Pick<Client,
    |'name'|'description'|'full_role_id'
    |'access_token'|'refresh_token'|'username'|'providers'
    |'is_published'|'state'|'authorized_redirect_uris'
  >> & {
    client_secret?: null;
  };
};
export type UpdateClientResponse = {
  client_secret?: string;
  request_id: string;
};

export async function updateClient(
  { api_url, headers }: ApiConfig,
  { tenant_id, client_name, body }: UpdateClientParams,
) {
  try {
    let res = await axios.patch<UpdateClientResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/clients/'+client_name, body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type DeleteClientParams = {
  tenant_id: string;
  client_name: string;
};
export type DeleteClientResponse = {
  request_id: string;
};

export async function deleteClient(
  { api_url, headers }: ApiConfig,
  { tenant_id, client_name }: DeleteClientParams,
) {
  try {
    let res = await axios.delete<DeleteClientResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/clients/'+client_name, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}
